var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAssistedLiving(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 800,
    height: 724,
    viewBox: "0 0 800 724",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M752.505 665.085H29.1738V256.246L44.883 209.073H725.954L752.505 256.246V665.085Z",
    fill: "#FF8086"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M532.36 586.461H500.911C492.227 586.461 485.186 579.42 485.186 570.737V476.389C485.186 467.705 492.227 460.664 500.911 460.664H532.36C541.044 460.664 548.085 467.705 548.085 476.389V570.737C548.085 579.422 541.046 586.461 532.36 586.461Z",
    fill: "#C3DDFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M485.186 570.737V586.461C485.186 595.145 492.225 602.186 500.911 602.186H532.36C541.046 602.186 548.085 595.145 548.085 586.461V570.737H485.186Z",
    fill: "#A4CCFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.1738 193.348H752.505V256.246H29.1738V193.348Z",
    fill: "#E5646E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M783.954 680.809H-2.27538C-10.959 680.809 -18 673.768 -18 665.085C-18 656.401 -10.959 649.36 -2.27538 649.36H783.954C792.638 649.36 799.679 656.401 799.679 665.085C799.679 673.77 792.64 680.809 783.954 680.809Z",
    fill: "#F4DBB3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M725.883 99H55.7957C49.2404 99 43.3739 103.065 41.0714 109.203L9.5177 193.348L20.4148 210.394H761.264L772.161 193.348L740.607 109.204C738.305 103.065 732.438 99 725.883 99Z",
    fill: "#857E87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M772.161 193.348H9.51748L5.69032 203.55C1.83608 213.83 9.43622 224.797 20.4146 224.797H123.522L138.081 214.585L154.973 224.797H249.32L264.49 214.585L280.768 224.797H375.116L392.835 214.585L406.565 224.797H500.911L516.987 214.585L532.36 224.797H626.704L640.335 214.585L658.153 224.797H761.26C772.238 224.797 779.838 213.83 775.984 203.55L772.161 193.348Z",
    fill: "#6F6571"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.971 350.594H123.522C114.838 350.594 107.797 343.553 107.797 334.869V303.42C107.797 294.737 114.838 287.696 123.522 287.696H154.971C163.655 287.696 170.696 294.737 170.696 303.42V334.869C170.696 343.553 163.655 350.594 154.971 350.594Z",
    fill: "#C3DDFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.797 334.869V350.594C107.797 359.278 114.836 366.319 123.522 366.319H154.971C163.656 366.319 170.696 359.278 170.696 350.594V334.869H107.797Z",
    fill: "#A4CCFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.971 586.461H123.522C114.838 586.461 107.797 579.42 107.797 570.737V476.389C107.797 467.705 114.838 460.664 123.522 460.664H154.971C163.655 460.664 170.696 467.705 170.696 476.389V570.737C170.696 579.422 163.655 586.461 154.971 586.461Z",
    fill: "#C3DDFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.797 570.737V586.461C107.797 595.145 114.836 602.186 123.522 602.186H154.971C163.656 602.186 170.696 595.145 170.696 586.461V570.737H107.797Z",
    fill: "#A4CCFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.246 161.898C130.562 161.898 123.521 168.939 123.521 177.623V193.348L139.246 209.072L154.971 193.348V177.623C154.971 168.937 147.93 161.898 139.246 161.898Z",
    fill: "#C3DDFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.043 161.898C256.359 161.898 249.318 168.939 249.318 177.623V193.348L265.043 209.072L280.768 193.348V177.623C280.768 168.937 273.727 161.898 265.043 161.898Z",
    fill: "#C3DDFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.84 161.898C382.156 161.898 375.115 168.939 375.115 177.623V193.348L390.84 209.072L406.565 193.348V177.623C406.565 168.937 399.524 161.898 390.84 161.898Z",
    fill: "#C3DDFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M516.635 161.898C507.952 161.898 500.911 168.939 500.911 177.623V193.348L516.635 209.072L532.36 193.348V177.623C532.36 168.937 525.321 161.898 516.635 161.898Z",
    fill: "#C3DDFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M642.432 161.898C633.749 161.898 626.708 168.939 626.708 177.623V193.348L642.432 209.072L658.157 193.348V177.623C658.157 168.937 651.118 161.898 642.432 161.898Z",
    fill: "#C3DDFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.521 193.348H154.971V224.797H123.521V193.348Z",
    fill: "#A4CCFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.319 193.348H280.768V224.797H249.319V193.348Z",
    fill: "#A4CCFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.115 193.348H406.565V224.797H375.115V193.348Z",
    fill: "#A4CCFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M500.913 193.348H532.362V224.797H500.913V193.348Z",
    fill: "#A4CCFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M626.708 193.348H658.157V224.797H626.708V193.348Z",
    fill: "#A4CCFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.768 350.594H249.319C240.635 350.594 233.594 343.553 233.594 334.869V303.42C233.594 294.737 240.635 287.696 249.319 287.696H280.768C289.452 287.696 296.492 294.737 296.492 303.42V334.869C296.492 343.553 289.452 350.594 280.768 350.594Z",
    fill: "#C3DDFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.594 334.869V350.594C233.594 359.278 240.633 366.319 249.319 366.319H280.768C289.453 366.319 296.492 359.278 296.492 350.594V334.869H233.594Z",
    fill: "#A4CCFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.565 350.594H375.115C366.432 350.594 359.391 343.553 359.391 334.869V303.42C359.391 294.737 366.432 287.696 375.115 287.696H406.565C415.248 287.696 422.289 294.737 422.289 303.42V334.869C422.289 343.553 415.248 350.594 406.565 350.594Z",
    fill: "#C3DDFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.391 334.869V350.594C359.391 359.278 366.43 366.319 375.115 366.319H406.565C415.25 366.319 422.289 359.278 422.289 350.594V334.869H359.391Z",
    fill: "#A4CCFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M532.36 350.594H500.911C492.227 350.594 485.186 343.553 485.186 334.869V303.42C485.186 294.737 492.227 287.696 500.911 287.696H532.36C541.044 287.696 548.085 294.737 548.085 303.42V334.869C548.085 343.553 541.046 350.594 532.36 350.594Z",
    fill: "#C3DDFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M485.186 334.869V350.594C485.186 359.278 492.225 366.319 500.911 366.319H532.36C541.046 366.319 548.085 359.278 548.085 350.594V334.869H485.186Z",
    fill: "#A4CCFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M658.157 350.594H626.708C618.024 350.594 610.983 343.553 610.983 334.869V303.42C610.983 294.737 618.024 287.696 626.708 287.696H658.157C666.841 287.696 673.882 294.737 673.882 303.42V334.869C673.882 343.553 666.843 350.594 658.157 350.594Z",
    fill: "#C3DDFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M610.983 334.869V350.594C610.983 359.278 618.022 366.319 626.708 366.319H658.157C666.843 366.319 673.882 359.278 673.882 350.594V334.869H610.983Z",
    fill: "#A4CCFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.768 586.461H249.319C240.635 586.461 233.594 579.42 233.594 570.737V476.389C233.594 467.705 240.635 460.664 249.319 460.664H280.768C289.452 460.664 296.492 467.705 296.492 476.389V570.737C296.492 579.422 289.452 586.461 280.768 586.461Z",
    fill: "#C3DDFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.594 570.737V586.461C233.594 595.145 240.633 602.186 249.319 602.186H280.768C289.453 602.186 296.492 595.145 296.492 586.461V570.737H233.594Z",
    fill: "#A4CCFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.565 586.461H375.115C366.432 586.461 359.391 579.42 359.391 570.737V476.391C359.391 467.707 366.432 460.666 375.115 460.666H406.565C415.248 460.666 422.289 467.707 422.289 476.391V570.739C422.289 579.422 415.248 586.461 406.565 586.461Z",
    fill: "#C3DDFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.391 570.737V586.461C359.391 595.145 366.43 602.186 375.115 602.186H406.565C415.25 602.186 422.289 595.145 422.289 586.461V570.737H359.391Z",
    fill: "#A4CCFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M800 533.333C800 581.205 782.341 624.952 753.18 658.414C718.261 698.484 666.85 715.736 609.525 715.736C504.328 715.736 427.614 638.53 427.614 533.333C427.614 476.03 444.353 424.637 484.397 389.719C517.866 360.533 561.631 342.856 609.526 342.856C714.72 342.858 800 428.136 800 533.333Z",
    fill: "#F5EBCD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M628.572 704.762C523.375 704.762 438.095 619.483 438.095 514.286C438.095 466.67 455.513 423.112 484.395 389.72C444.334 424.637 419.048 476.017 419.048 533.334C419.048 638.531 504.328 723.811 609.525 723.811C666.842 723.811 718.262 698.476 753.18 658.416C719.786 687.297 676.188 704.762 628.572 704.762V704.762Z",
    fill: "#F4DBB3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M698.413 507.936H634.92V444.444C634.92 437.431 629.234 431.745 622.222 431.745H596.825C589.813 431.745 584.127 437.431 584.127 444.444V507.936H520.634C513.622 507.936 507.936 513.622 507.936 520.634V533.333L595.039 547.817L609.524 634.92H622.222C629.234 634.92 634.92 629.234 634.92 622.222V558.73H698.413C705.425 558.73 711.111 553.044 711.111 546.031V520.634C711.111 513.622 705.427 507.936 698.413 507.936V507.936Z",
    fill: "#FF8086"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M507.936 546.031C507.936 553.044 513.622 558.73 520.634 558.73H584.127V622.222C584.127 629.235 589.813 634.92 596.825 634.92H609.524V558.73C609.524 544.703 598.153 533.333 584.127 533.333H507.936V546.031Z",
    fill: "#E5646E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 800,
    height: 724,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssistedLiving);
export default __webpack_public_path__ + "static/media/assisted-living.9e98d348aac6e14992340e82734295fe.svg";
export { ForwardRef as ReactComponent };